import { Button } from '@pets-ui/Button/Button'
import { HStack } from '@pets-ui/HStack/HStack'
import { Input } from '@pets-ui/Input/Input'
import { Text } from '@pets-ui/Text/Text'
import * as stylex from '@stylexjs/stylex'
import { isEmail } from '@utils'
import Cookies from 'js-cookie'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Service } from '../../Service'
import { CardTitleWithIcon } from '../CardTitleWithIcon'
import { DividerOr } from '../DividerOr'
import { loginStepGroupBuying } from '../types'
import { useContextLoginGroupBuying } from './useContextLoginGroupBuying'

const styles = stylex.create({
  confirmButton: {
    marginTop: '20px',
  },
  suffix: {
    marginBottom: '10px',
  },
})

export function LoginEmailGroupBuying() {
  const { t } = useTranslation()
  const { setStep, email, setEmail, backLoginUrl, countryCode, emailDomain } = useContextLoginGroupBuying()
  const [emailError, setEmailError] = useState('')

  const handleClickConfirm = () => {
    if (!email || !countryCode) return

    if (!isEmail(email + emailDomain)) {
      setEmailError(String(t('error.incorrectEmailFormat')))
      return
    }
    setEmail(email + emailDomain)
    Cookies.set('account', email + emailDomain)
    Cookies.set('country_code', countryCode)
    setStep(loginStepGroupBuying.VALIDATE_EMAIL)
    setEmailError('')
  }

  const handleClickBackLogin = () => {
    window.location.href = backLoginUrl
  }

  return (
    <>
      <CardTitleWithIcon
        title={t('login.emailLogin')}
      />
      <HStack gap={3} flexWrap="nowrap" alignItems="flex-end">
        <Input
          label={t('login.email')}
          fullWidth
          placeholder={String(t('login.pleaseEnter'))}
          name="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          error={!!emailError}
          helpText={emailError}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleClickConfirm()
            }
          }}
        />
        <Text variant="h5" rootStyle={styles.suffix}>{emailDomain}</Text>
      </HStack>
      <Button
        fullWidth
        disabled={email?.trim() === ''}
        rootStyle={styles.confirmButton}
        onClick={handleClickConfirm}
      >
        {t('button.confirm')}
      </Button>
      <DividerOr />
      <Button variant="ghost" color="grey" fullWidth onClick={handleClickBackLogin}>{t('login.returnToLogin')}</Button>
      <Service />
    </>
  )
}
